module.exports = __webpack_public_path__ + "img/switch_img1.aea5281f.png";